
export class CreateApiKeyDto {
  constructor(data) {
    this.userId = data.userId;
    this.partnerCode = data.partnerCode;
    this.partnerName = data.partnerName;
    this.description = data.description;
    this.status = Boolean(data.status);
  }
}
